import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

import { IPublicationCustomCssDialogsMessages } from '../../../../../types';

import { styles } from './DiscardCustomCssDialog.styles';

export type IDiscardCustomCssDialogProps = {
  messages: IPublicationCustomCssDialogsMessages;
  onDiscard(): void;
  onCancel(): void;
};

export const DiscardCustomCssDialog: React.FC<IDiscardCustomCssDialogProps> = (props) => {
  const { messages, onCancel, onDiscard } = props;
  return (
    <Dialog
      open={true}
      onClose={onCancel}
      data-test="custom-css-discard-dialog"
      aria-labelledby="discard-custom-css-dialog-title"
    >
      <DialogTitle id="discard-custom-css-dialog-title" sx={styles.dialogTitle}>
        {messages.discardChanges}
        <IconButton aria-label="close" onClick={onCancel} size="small" sx={styles.closeButton}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{messages.changesWillBeLost}</DialogContentText>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button
          variant="outlined" size="small"
          color="secondary"
          onClick={onCancel}
          data-test="custom-css-discard-cancel"
        >
          {messages.cancel}
        </Button>
        <Button
          variant="contained" size="small"
          color="primary"
          onClick={onDiscard}
          data-test="custom-css-discard"
        >
          {messages.discard}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
